export const HEADER = 'TECH FARM'
export const VALUE = 5
